// extracted by mini-css-extract-plugin
export default {"header":"SuggestChangesModal_header__YE6Vc","content":"SuggestChangesModal_content__WbFNx","divider":"SuggestChangesModal_divider__SQ+dE"};